import { useAuth } from '../../features/auth/auth-context';
import { shouldShowStaffDashboard } from '../../features/auth/portal-access';

import { AdminOperationalDashboardPage } from './admin/AdminOperationalDashboardPage';
import { CustomerDashboardPage } from './customer/CustomerDashboardPage';

/**
 * Route-level dashboard switcher.
 *
 * Staff with reporting or user-management access see the operational overview;
 * customers see their own repayment journey summary.
 */
export function DashboardPage(): React.JSX.Element {
  const { user, can } = useAuth();

  if (shouldShowStaffDashboard(user, can)) {
    return <AdminOperationalDashboardPage />;
  }

  return <CustomerDashboardPage />;
}
